import { translate } from '@jsverse/transloco';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-export-button',
    imports: [ButtonComponent],
    templateUrl: './export-button.component.html',
    styleUrl: './export-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportButtonComponent {
    @Input()
    disabled: boolean = false;

    @Input()
    loading: boolean = false;

    @Input()
    tooltip: string = translate('COMMON_UI.TABLE.EXPORT');

    @Output()
    trigger: EventEmitter<void> = new EventEmitter<void>();
}
